module.exports = __webpack_public_path__ + "static/media/img11.b4078e86.jpeg";